import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'reactstrap';

/**
 * Componente de alerta flotante que se muestra en la parte inferior de la pantalla
 * @param {boolean} isOpen - Controla si la alerta está visible
 * @param {string} message - Mensaje a mostrar
 * @param {string} type - Tipo de alerta (success, warning, danger, info)
 * @param {string} icon - Ícono de Material Design Icons (ej: 'check-circle')
 */
const BottomAlert = ({ isOpen, message, type = 'success', icon = 'check-circle' }) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        minWidth: '400px',
        maxWidth: '90%',
      }}
    >
      <Alert color={type} className="mb-0 d-flex align-items-center">
        <i className={`mdi mdi-${icon} mr-2`} style={{ fontSize: '20px' }}></i>
        <span>{message}</span>
      </Alert>
    </div>
  );
};

BottomAlert.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['success', 'warning', 'danger', 'info']),
  icon: PropTypes.string,
};

export default BottomAlert;

